import { createTheme } from "@material-ui/core";
const secondaryAppBar = {
    typography: {
    //useNextVariants: true,
    },
    // grow: {
    //   flexGrow: 1,
    // },
    palette: {
        primary: {
            light: "#293445",
            main: "#293445",
            dark: "#293445",
            contrastText: "#fff",
        },
        secondary: {
            light: "#293445",
            main: "#293445",
            dark: "#293445",
            contrastText: "#fff",
        },
    },
    // MuiButton: {
    //   textPrimary: {
    //     color: "#fff",
    //   },
    // },
    overrides: {
        MuiButton: {
            // color: "#ffffff", // todo: remove this as mui warnings appear in console
            textPrimary: {
                // color: "#ffffff",
                "&:hover": {
                    backgroundColor: "#f9f9f9",
                },
            },
        },
        MuiInputLabel: {
            filled: {
                zIndex: 0,
            },
        },
        MuiFormLabel: {
            root: {
                "&$focused": {
                    color: "#1b57b2",
                },
            },
        },
        MuiInput: {
            underline: {
                "&:after": {
                    borderBottomColor: "#1b57b2",
                },
            },
        },
        MuiTabs: {
            root: {},
        },
        MuiSvgIcon: {
            root: {
            // fill: "white",
            },
        },
        // IconButton: {
        //   color: "#fff",
        // },
        // paper: {
        //   backgroundColor: "red",
        // },
        MuiAppBar: {
            positionFixed: {
            // "@media (min-width: 0px)": {
            //   marginTop: "50px",
            // },
            // "@media (min-width: 0px) and (orientation: landscape)": {
            //   marginTop: "50px",
            // },
            // "@media (min-width: 600px)": {
            //   marginTop: "50px",
            // },
            // height: "50px",
            // // padding: "6px",
            // left: "240px",
            // width: "auto",
            // zIndex: 1000,
            },
        },
    },
};
export const complaintsTheme = createTheme(secondaryAppBar);
// export default class MuiTheme {
//   public getSecondaryAppBar(): any {
//     return
//   }
// }
